import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Undo = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24">
    <g clipPath="url(#clip0_9132_17992)">
      <path
        d="M11.4061 10.5143C10.279 10.6857 9.28453 11.0286 8.35635 11.6571L6.5 10V14H11.1409L9.35083 12.4571C11.8039 10.9714 15.1851 11.4286 16.9751 13.5429C17.1077 13.7143 17.2403 13.8286 17.3066 14L18.5 13.4857C17.0414 11.3143 14.2569 10.1143 11.4061 10.5143Z"
        fill="#7F91AD"
      />
    </g>
    <defs>
      <clipPath id="clip0_9132_17992">
        <path
          d="M0.5 4C0.5 1.79086 2.29086 0 4.5 0H20.5C22.7091 0 24.5 1.79086 24.5 4V20C24.5 22.2091 22.7091 24 20.5 24H4.5C2.29086 24 0.5 22.2091 0.5 20V4Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </SvgIcon>
));

export default React.memo(Undo);
